import utils from '../../utils/tag-name';

const TAG_NAME = utils.constructTagName('formfieldgroup');

export { TAG_NAME };
